import styles from "./CreateAlbum.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import React, { useState } from "react";
import CreateAlbumSubsection01 from "./CreateAlbumSubsection01";
import { CreateAlbumPictureRow } from "./CreateAlbumPictureRow";
import { useRef } from "react";
import useAxios from "../Hooks/useAxios";
import { useNavigate } from "react-router-dom";
const CreateAlbum = () => {
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios({
    "Content-type": "multipart/form-data",
  });
  const [nextImageID, setNextImageID] = useState(1);
  const imageInputRef = useRef(null);
  const [images, setImages] = useState([]);
  const [imageSizes, setImageSizes] = useState([]);
  const [nameSelectSection, setNameSelectSection] = useState(true);
  const [imageChunks, setImageChunks] = useState([]);
  const [albumName, setAlbumName] = useState("");
  const handleAlbumNameChange = (e) => {
    if (e.target.value.length === 0 && e.target.value.length > 10) {
      return;
    }
    setAlbumName(e.target.value);
  };
  const handleMainClick = () => {
    if (nameSelectSection && albumName.length !== 0) {
      setNameSelectSection(false);
    } else if (!nameSelectSection) {
      openImageUploadWindow();
    }
  };
  const createGallery = () => {
    console.log("Album will be created");
    console.log(imageChunks);
    console.log(images);
    const data = new FormData();
    data.append("album_name", albumName);
    for (let image of images) {
      console.log(image);
      data.append("images", image, image.name);
    }
    axios
      .post(backend_base + "/shop/album/create", data, {})
      .then((res) => {
        if (res.status === 201) {
          navigate("/create-album-success", {
            state: {
              title: res.data?.album?.name,
              uploadDate: res.data?.album?.created_date,
              expiryDate: res.data?.album?.expiry_date,
            },
          });
        } else {
          console.log("Failed");
          alert("Failed to Create Gallery");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const removeImageByID = (idToRemove) => {
    console.log(idToRemove);
    const indexToRemove = images.findIndex((image) => image.id === idToRemove);
    console.log("index to remove: ", indexToRemove);
    if (indexToRemove !== -1) {
      const temp = images.filter((image) => image.id !== idToRemove);
      temp.map((item, index) => console.log(item.id));
      setImages(temp);
      setImageSizes(imageSizes.splice(indexToRemove, 1));
      const chunk = [];
      for (let i = 0; i < temp.length; i += 5) {
        chunk.push(temp.slice(i, i + 5));
      }
      setImageChunks(chunk);
    }
  };
  const openImageUploadWindow = () => {
    console.log("Open File Selector");
    imageInputRef.current.click();
  };

  const handleImageFileChange = (event) => {
    if (images.length === 20) {
      return;
    }
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    const files = event.target.files;
    console.log(files);
    let currentID = nextImageID;
    let currentImagesLength = images.length;
    const tempImages = [...images];
    const tempImageSizes = [...imageSizes];
    for (let i = 0; i < files.length; i++) {
      if (currentImagesLength === 20) {
        break;
      } else {
        currentImagesLength++;
      }
      const fileObj = files[i];
      console.log("Uploaded fileObj is:", fileObj);
      fileObj.id = currentID;
      currentID++;
      tempImages.push(fileObj);
      tempImageSizes.push(fileObj.size);
      // your existing code for processing a single file goes here
    }

    event.target.value = null;
    setNextImageID(currentID);

    setImages(tempImages);
    setImageSizes(tempImageSizes);
    const chunk = [];
    for (let i = 0; i < tempImages.length; i += 5) {
      chunk.push(tempImages.slice(i, i + 5));
    }

    // Store the image chunks in the imageChunks state variable
    console.log("chunk is");
    console.log(chunk);
    setImageChunks(chunk);
  };

  return (
    <div className={styles.album_wrapper_body_div}>
      <Header />
      <div className={styles.album_body_div}>
        {nameSelectSection && (
          <div className={styles.album_nameSelection_header}>
            撮影データアップロード
          </div>
        )}
        {!nameSelectSection && (
          <div className={styles.album_nameSelection_false_header}>
            アップロード確認
          </div>
        )}

        <CreateAlbumSubsection01
          disableTextBox={!nameSelectSection}
          textBoxContent={nameSelectSection ? albumName : albumName}
          handleTextChange={handleAlbumNameChange}
          maxLength={10}
        />

        <div className={styles.album_body_main_button}>
          <button onClick={handleMainClick}>
            {nameSelectSection && "フォルダ選択"}
            {!nameSelectSection && "+ 写真を追加"}
          </button>
          <input
            style={{ display: "none" }}
            ref={imageInputRef}
            type="file"
            onChange={handleImageFileChange}
            accept="image/gif, image/jpeg, image/png, image/jpg"
            multiple
          />
        </div>
        <div styles={styles.album_bottom_section_div}>
          {nameSelectSection && (
            <div
              className={styles.album_body_all_pictures_div_fake_space}
            ></div>
          )}
          {!nameSelectSection && (
            <div className={styles.album_body_all_pictures_div}>
              {imageChunks.map((chunk, index) => {
                console.log("inside chunk 01");
                return (
                  <CreateAlbumPictureRow
                    key={index}
                    pictures={chunk}
                    removeByID={removeImageByID}
                  />
                );
              })}
              {imageChunks.length !== 0 && (
                <div className={styles.album_body_create_gallery_button_div}>
                  <button onClick={createGallery} style={{ border: "0px" }}>
                    ギャラリーへアップロード
                  </button>
                </div>
              )}
            </div>
          )}
          {<Footer />}
        </div>
      </div>
      {/* {nameSelectSection && <Footer />} */}
    </div>
  );
};
export default CreateAlbum;
